import type { Dataset, DatasetProps } from './datasetsTypes';
import { mkDataset } from './datasetsTypes';

export const transformResponseToDatasets = (response: any): Array<Dataset> =>
  response.data.resources.map((data: DatasetProps) =>
    mkDataset({
      clientId: data.clientId,
      id: data.id,
      name: data.name,

      platform: data.platform,
      subscriptionTier: data.subscriptionTier,
      createdByClientId: data.createdByClientId,
      createdAt: data.createdAt,
      lastSyncedAt: data.lastSyncedAt,
      lastAccessedAt: data.lastAccessedAt,
      zipcode: data.zipcode,
      itemAccessControl: data.itemAccessControl ? JSON.parse(data.itemAccessControl) : undefined,

      // was a defect on QCS that returned true when it really wasn't shared so we also validate we have a grantor field
      shared: data.shared && Boolean(data.grantorUsername),
      grantorFirstName: data.grantorFirstName,
      grantorLastName: data.grantorLastName,
      grantorUsername: data.grantorUsername,
      permissions: data.permissions,

      disableRemoteAccess: data.disableRemoteAccess,
      isDeleted: data.isDeleted,
      headless: data.headless,
      ownerId: data.ownerId,
    }),
  );
